import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

import { categoryEndpoints } from './category.constants'
import type { TCategory } from './category.types'

// Kategoriler Bilgilig internal API'den canlı proxy ile gelir (yerel tablo yok). Backend
// `GET /categories` sayfalamasız düz liste döner; hem liste sayfası hem üretim dropdown'ı kullanır.
export async function getCategoryList(): Promise<TCategory[]> {
  const res = await api.get<TResponse<TCategory[]>>(categoryEndpoints.list)
  return res.data.data
}
